import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    templateUrl: './termos-contratacao-modal.component.html',
    standalone: false
})
export class TermosContratacaoModalComponent {

    public callback: any;
    cienciaDosTermosConfirmada = false;

    constructor(private _activeModal: NgbActiveModal) {
    }

    public cancelar() {
        this._activeModal.dismiss({});
    }

    public ok() {
        this._activeModal.dismiss({});
        this.callback();
    }

    changeCheck(event) {
        this.cienciaDosTermosConfirmada = event.target.checked;
    }
}